<template>
  <div>
    <div class="sessionStatusCard" v-if="setPreSession">
      <div class="d-flex flex-column justify-space-around fill-height">
        <div class="statusTitle ">
          <div class="d-flex justify-space-between">
            <div class="d-flex">
              <div>
                <img src="../../assets/image/png/session/tik.png" width="40px" class="mt-1" alt="">
              </div>
              <div class="mt-2 mr-2">
                برای رزرو جلسه پیش‌مشاوره و مشخص شدن مشاور اقدام کنید
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="statusTitleArea">
            <div class="needToBuy" :class="!$vuetify.rtl && 'text-left'">
              جلسه پیش‌مشاوره در 15 دقیقه برگزار می‌شود تا سیمیاروم متناسب با مساله و ترجیحات شما اقدام به انتخاب مشاور
              ‌نماید.
            </div>
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="mt-3">
          </div>
          <div class="statusLabel">
            <router-link :to="{name:'onboarding_new'}" style="text-decoration: none">
              <div class="BuyAction d-flex mt-3">
                <div class="ml-2">
                  رزرو جلسه پیش‌مشاوره
                </div>
                <img src="../../assets/image/png/session/buy.png" :class="!$vuetify.rtl && 'en_arrow'"
                     style="border-radius: 5px" alt="">
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="sessionStatusCard" v-if="userOnbording">
      <div class="d-flex flex-column justify-space-around fill-height">
        <div class="statusTitle ">
          <div class="d-flex justify-space-between">
            <div class="d-flex">
              <div>
                <img src="../../assets/image/png/session/tik.png" width="40px" class="mt-1" alt="">
              </div>
              <div class="mt-2 mr-2">
                اطلاعات حساب کاربری خود را تکمیل کنید.
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="statusTitleArea">
            <div class="needToBuy" :class="!$vuetify.rtl && 'text-left'">
              <!--              جلسه پیش‌مشاوره در 45 دقیقه برگزار می‌شود تا سیمیاروم با دید بهتری مشاور مناسب شما انتخاب کند-->
            </div>
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="mt-3">
          </div>
          <div class="statusLabel">
            <router-link :to="{name:'userOnboarding'}" style="text-decoration: none">
              <div class="BuyAction d-flex mt-3">
                <div class="ml-2">
                  تکمیل اطلاعات حساب
                </div>
                <img src="../../assets/image/png/session/buy.png" :class="!$vuetify.rtl && 'en_arrow'"
                     style="border-radius: 5px" alt="">
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      'profile': 'getProfile',
    })
  },
  data() {
    return {
      setPreSession: false,
      userOnbording: false,
    }
  },
  methods: {
    checkUser() {
      if ((this.profile.requiredFields.length != 0 || this.profile.cycles.length == 0) && !this.profile.leadUser) {
        this.setPreSession = true
      }
      if (this.profile.requiredFields.length != 0 && this.profile.leadUser) {
        this.userOnbording = true
      }
    }
  },
  created() {
    this.checkUser()
  },
  watch: {
    profile() {
      this.checkUser()
    }
  }
}
</script>

<style scoped>


.sessionStatusCard {
  width: 100%;
  background: white;
  border-radius: 18px;
  padding: 25px;
  border: solid 1px #d1dcff;
}

.statusTitle {
  font-size: 20px;
}

.statusTitleArea {
  padding-right: 5px;
}

.statusLabel {
  text-decoration: none !important;
}

.needToBuy {
  /* Typo/Title2/Regular/Right */
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  /* identical to box height, or 138% */
  text-align: right;
  /* label secondary */
  color: #959595;
}


.BuyAction {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3CBE8B;
}

</style>
